var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMicrowaves = function SvgMicrowaves(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICONS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,161.11a20,20,0,0,0-20,20V459.66a21,21,0,0,0,21,21H438V161.11Zm333.85,44.1v232H90.86a16,16,0,0,1-16-16V220.12a16,16,0,0,1,16-16h293Zm28.92,205.64a2.06,2.06,0,0,1-2.06,2.06h-7.21a2.05,2.05,0,0,1-2-2.06V238.66a2.05,2.05,0,0,1,2-2h7.21a2.05,2.05,0,0,1,2.06,2Z",
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.59,161.11H438V480.66H560.59a21,21,0,0,0,21-21V181.11A20,20,0,0,0,561.59,161.11Zm-100.65,51a8,8,0,0,1,8-8h81.73a8,8,0,0,1,8,8v47.59a8,8,0,0,1-8,8H468.94a8,8,0,0,1-8-8Zm58.41,104.41H500.92a3,3,0,0,1-3-3v-13a3,3,0,0,1,3-3h18.43a3,3,0,0,1,3,3v13A3,3,0,0,1,519.35,316.53Zm3,17.29v13a3,3,0,0,1-3,3H500.92a3,3,0,0,1-3-3v-13a3,3,0,0,1,3-3h18.43A3,3,0,0,1,522.35,333.82Zm-36.64-33.29v13a3,3,0,0,1-3,3H464.27a3,3,0,0,1-3-3v-13a3,3,0,0,1,3-3h18.44A3,3,0,0,1,485.71,300.53Zm-24.44,46.28v-13a3,3,0,0,1,3-3h18.44a3,3,0,0,1,3,3v13a3,3,0,0,1-3,3H464.27A3,3,0,0,1,461.27,346.81Zm52.12,108.87A36.65,36.65,0,1,1,550,419,36.65,36.65,0,0,1,513.39,455.68ZM559,346.81a3,3,0,0,1-3,3H537.57a3,3,0,0,1-3-3v-13a3,3,0,0,1,3-3H556a3,3,0,0,1,3,3Zm0-33.28a3,3,0,0,1-3,3H537.57a3,3,0,0,1-3-3v-13a3,3,0,0,1,3-3H556a3,3,0,0,1,3,3Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.86,220.12V421.19a16,16,0,0,0,16,16h293L237,205.21H383.81v-1.09H90.86A16,16,0,0,0,74.86,220.12Z",
    fill: "#16a99e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.41,
    y: 236.61,
    width: 11.32,
    height: 176.3,
    rx: 2.05,
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.94,
    y: 204.12,
    width: 97.72,
    height: 63.59,
    rx: 8,
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.27,
    y: 297.53,
    width: 24.43,
    height: 19,
    rx: 3,
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.92,
    y: 297.53,
    width: 24.43,
    height: 19,
    rx: 3,
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.57,
    y: 297.53,
    width: 24.43,
    height: 19,
    rx: 3,
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.27,
    y: 330.82,
    width: 24.43,
    height: 19,
    rx: 3,
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.92,
    y: 330.82,
    width: 24.43,
    height: 19,
    rx: 3,
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.57,
    y: 330.82,
    width: 24.43,
    height: 19,
    rx: 3,
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.39,382.39A36.65,36.65,0,1,0,550,419,36.65,36.65,0,0,0,513.39,382.39Zm0,63.34A26.7,26.7,0,1,1,540.08,419,26.69,26.69,0,0,1,513.39,445.73Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 513.39,
    cy: 419.04,
    r: 26.7,
    transform: "matrix(0.92, -0.38, 0.38, 0.92, -121.28, 228.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.81 437.19 383.81 205.21 236.96 205.21 383.81 437.19",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.12,74.5c3.26,0,30.11,1,30.11,32.62a3.32,3.32,0,0,0,3.25,3.26c1.51.25,3-1.25,3-3,0-31.61,27.09-32.62,30.1-32.62h.25a3.37,3.37,0,0,0,3.26-3.51A3.32,3.32,0,0,0,128.85,68c-3,0-30.1-1-30.1-32.61a3.26,3.26,0,1,0-6.52,0C92.23,67,65.13,68,62.12,68h-.25a3.27,3.27,0,0,0-3,3.26A3.31,3.31,0,0,0,62.12,74.5Z",
    fill: "#fff"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicrowaves, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/microwaves.192f777c.svg";
export { ForwardRef as ReactComponent };